// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","vGutterX":"30px","tablet-landscape-up":"(min-width: calc(1024 * 1px))","block":"InfoBlock_block__19VZs"};